import { render, staticRenderFns } from "./appraiserSystem.vue?vue&type=template&id=0f0aa022"
import script from "./appraiserSystem.vue?vue&type=script&lang=js"
export * from "./appraiserSystem.vue?vue&type=script&lang=js"
import style0 from "./appraiserSystem.vue?vue&type=style&index=0&id=0f0aa022&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports